import { render } from "./KeyBoard.vue?vue&type=template&id=4747e947&scoped=true"
import script from "./KeyBoard.vue?vue&type=script&lang=js"
export * from "./KeyBoard.vue?vue&type=script&lang=js"

import "./KeyBoard.vue?vue&type=style&index=0&id=4747e947&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4747e947"]])

export default __exports__